export default __webpack_public_path__ + "static/18-4cc0a634afae37e16540361aa9033acc.png";